<template>
	<tr>
		<th></th>
		<th :key="`stats-year-${year}`" v-for="year in roundYearRange">
			{{ year }}
		</th>
		<th>Last Round</th>
		<th>Last 3 rounds</th>
		<th>Last 6 Rounds</th>
		<th>All</th>
	</tr>
</template>
<script>
export default {
    name: "StatisticsTableHead",
    props: {
        roundYearRange: {
            type: Array,
            required: true
        }
    }
}
</script>